import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'


const TableExpanded = React.memo((props) => {
  return (
    <div className="row">
      <TableResult {...props} numSector={'1'} />
      <TableResult {...props} numSector={'2'} />
    </div>
  );
}, (prevProps, nextProps) => {
  //Si retornamos true:  No se renderiza
  //Si retornamos false: Si se renderiza
  return (
    //renderizamos cuando un dato de los visibles cambia
    arraysEqual(prevProps, nextProps)
  )
});

function TableResult(props) {
  const { row } = props;
  const { config } = props;
  const data = getDataFormated(row, config, props.numSector)
  return (
    <div className="col-lg-6">
      <table className="table table-detail">
        <caption>{config?.find(item => item.ei_code === 'SECTOR' && item.ei_pos === props.numSector).ei_value}</caption>
        <thead>
          <tr>
            <th rowSpan='2' className="w-10 text-center"><Label data="HeaderEnd" /></th>
            <th colSpan='6' className="text-center"><Label data="HeaderArrows" /></th>
            <th colSpan='2' className="text-center"><Label data="HeaderTotals" /></th>
            <th rowSpan='2' className="w-10 text-end"><Label data="HeaderTens" /></th>
            <th rowSpan='2' className="w-10 text-end"><Label data="HeaderXs" /></th>
          </tr>
          <tr>
            <th className="w-5 text-end">1</th>
            <th className="w-5 text-end">2</th>
            <th className="w-5 text-end">3</th>
            <th className="w-5 text-end">4</th>
            <th className="w-5 text-end">5</th>
            <th className="w-5 text-end">6</th>
            <th className="w-10 text-end"><Label data="HeaderEnd" /></th>
            <th className="w-10 text-end"><Label data="HeaderSum" /></th>
          </tr>
        </thead>
        <tbody>
          {data && data?.map((item, key) => (
            <tr key={'expanded_' + key}>
              <td className="text-center">{item?.set}</td>
              <td className="text-end">{item?.arrow1}</td>
              <td className="text-end">{item?.arrow2}</td>
              <td className="text-end">{item?.arrow3}</td>
              <td className="text-end">{item?.arrow4}</td>
              <td className="text-end">{item?.arrow5}</td>
              <td className="text-end">{item?.arrow6}</td>
              <td className="text-end">{item.totalEnds}</td>
              <td className="text-end fw-bold">{item.totalSums}</td>
              <td className="text-end">{item.ten_num}</td>
              <td className="text-end">{item.xs_num}</td>

            </tr>
          )
          )}
        </tbody>
      </table>
    </div>
  )
}

function getDataFormated(row, config, sectorNum) {
  const sector = config?.find(item => item.ei_code === 'SECTOR' && item.ei_pos === '1')
  const sectorArrows = sector?.extensions?.find(item => item.eie_code === 'ARROW_NUM')?.eie_value

  const sectorSetMax = config?.find(item => item.ei_code === 'ARROW_SET')?.extensions.find(extension => extension.eie_code === 'ARROW_ID' && extension.eie_pos === sectorArrows)?.eie_value

  let sets
  if (sectorNum === '1') {
    sets = config?.find(item => item.ei_code === 'SET')?.extensions.filter(extension => extension.eie_code === 'ARROW_NUM' && Number(extension?.eie_pos) <= Number(sectorSetMax)).sort((a, b) => a.eie_pos - b.eie_pos);
  } else {
    sets = config?.find(item => item.ei_code === 'SET')?.extensions.filter(extension => extension.eie_code === 'ARROW_NUM' && Number(extension?.eie_pos) > Number(sectorSetMax)).sort((a, b) => a.eie_pos - b.eie_pos);
  }
  const arrowsSets = config?.find(item => item.ei_code === 'ARROW_SET')?.extensions.filter(extension => extension.eie_code === 'ARROW_ID').sort((a, b) => a.eie_pos - b.eie_pos);
  let dataArray = [];
  sets.map(set => {
    //console.log('set:' + set.eie_pos)
    let arrows = arrowsSets.filter(arrow => arrow.eie_value === set.eie_pos)
    let numSector = arrowsSets.ei_pos <= sectorArrows ? 1 : 2;
    let numSet = set?.eie_pos;
    let setValues = row?.extendedResults?.find(res => res?.er_code === 'SET' && res?.er_pos === numSet)
    let line = {
      set: numSet,
      totalEnds: setValues?.extensions?.find(ext => ext.ere_code === 'ARROW_TOT')?.ere_value,
      totalSums: setValues?.er_value,
      ten_num: setValues?.extensions?.find(ext => ext.ere_code === 'TEN_NUM')?.ere_value,
      xs_num: setValues?.extensions?.find(ext => ext.ere_code === 'XS_NUM')?.ere_value,

    }
    arrows.map((arrow, index) => {
      let key = 'arrow' + (index + 1);
      line[key] = row?.extendedResults?.find(res => res?.er_code === 'ARROW' && res?.er_pos === arrow?.eie_pos)?.er_value
    }
    )
    dataArray.push(
      line
    )

  })

  return (
    dataArray
  )
}


function getColumns(cols, discipline) {

  const columns =
    [
      ...createColumns(cols, discipline),
    ]

  return columns

}


export function createColumns(config, discipline) {
  let columnsExt = []
  Array.isArray(config) &&
    config.forEach((item) => {
      if (typeof item === 'object') {
        columnsExt.push(
          {
            id: capitalize(item.id),
            Header: item?.config?.header && <Label data={item?.config?.header} sport={discipline} />,
            headerClassName: "w-5 text-end",
            accessor: item.id,
            disableSortBy: true,
            className: "text-end"
          },
        )
      } else {
        columnsExt.push(
          {
            id: capitalize(item),
            Header: <Label data={labeledHeader(capitalize(item))} />,
            headerClassName: "w-5 text-end",
            accessor: item,
            disableSortBy: true,
            className: "text-end"
          },
        )
      }
    })
  return columnsExt
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function labeledHeader(str) {
  return "Header" + str;
}
export default TableExpanded;